module.exports = __webpack_public_path__ + "static/media/S4N2-4.01730794.svg";